var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2.5a.5.5 0 0 1 .5-.5H21a1 1 0 0 1 1 1v5.5a.5.5 0 0 1-1 0V3.707L8.854 15.854a.5.5 0 0 1-.708-.708L20.293 3H15.5a.5.5 0 0 1-.5-.5M4.5 4A2.5 2.5 0 0 0 2 6.5v13A2.5 2.5 0 0 0 4.5 22h13a2.5 2.5 0 0 0 2.5-2.5v-7a.5.5 0 0 0-1 0v7a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 3 19.5v-13A1.5 1.5 0 0 1 4.5 5h7a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgNewTab = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewTab);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAyLjVDMTUgMi4yMjM4NiAxNS4yMjM5IDIgMTUuNSAySDIxQzIxLjU1MjMgMiAyMiAyLjQ0NzcyIDIyIDNWOC41QzIyIDguNzc2MTQgMjEuNzc2MSA5IDIxLjUgOUMyMS4yMjM5IDkgMjEgOC43NzYxNCAyMSA4LjVWMy43MDcxMUw4Ljg1MzU1IDE1Ljg1MzZDOC42NTgyOSAxNi4wNDg4IDguMzQxNzEgMTYuMDQ4OCA4LjE0NjQ1IDE1Ljg1MzZDNy45NTExOCAxNS42NTgzIDcuOTUxMTggMTUuMzQxNyA4LjE0NjQ1IDE1LjE0NjRMMjAuMjkyOSAzSDE1LjVDMTUuMjIzOSAzIDE1IDIuNzc2MTQgMTUgMi41Wk00LjUgNEMzLjExOTI5IDQgMiA1LjExOTI5IDIgNi41VjE5LjVDMiAyMC44ODA3IDMuMTE5MjkgMjIgNC41IDIySDE3LjVDMTguODgwNyAyMiAyMCAyMC44ODA3IDIwIDE5LjVWMTIuNUMyMCAxMi4yMjM5IDE5Ljc3NjEgMTIgMTkuNSAxMkMxOS4yMjM5IDEyIDE5IDEyLjIyMzkgMTkgMTIuNVYxOS41QzE5IDIwLjMyODQgMTguMzI4NCAyMSAxNy41IDIxSDQuNUMzLjY3MTU3IDIxIDMgMjAuMzI4NCAzIDE5LjVWNi41QzMgNS42NzE1NyAzLjY3MTU3IDUgNC41IDVIMTEuNUMxMS43NzYxIDUgMTIgNC43NzYxNCAxMiA0LjVDMTIgNC4yMjM4NiAxMS43NzYxIDQgMTEuNSA0SDQuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";